import React from "react";
import Navbar from "../Navbar/Navbar";
import classes from "./Home.module.css";
import CustomCarousel from "../Carousel/Carousel";
import EnergySupplyImage from "../../assest/energy-grid-hero.jpg";
import EnergyTradingImage from "../../assest/energy-trading-control-room.jpg";
import GridBalancingImage from "../../assest/grid-balancing-assets.jpg";
import FieldServiceImage from "../../assest/ancillary-field-service.jpg";
import CpoPlatformImage from "../../assest/cpo-ocpp-ev-charging-platform.jpg";
import ContactUs from "../ContactUs/ContactUs";
import Footer from "../Footer";

// import ContactUs from "../ContactUs/ContactUs";

const Home = () => {
  const carouselContent = [
    {
      title: "Energy Supply",
      text: "Flexible power supply services for commercial, industrial, and grid-support requirements.",
      image: EnergySupplyImage,
    },
    {
      title: "Energy Trading",
      text: "Market participation, portfolio optimization, and trading support for dynamic energy needs.",
      image: EnergyTradingImage,
    },
    {
      title: "Grid Balancing",
      text: "Load banks, batteries, and dispatchable assets delivered to help stabilize grid conditions.",
      image: GridBalancingImage,
    },
    {
      title: "Ancillary Services",
      text: "Operational services, equipment, and response capacity for frequency and reserve support.",
      image: FieldServiceImage,
    },
    {
      title: "Industrial IoT",
      text: "High-frequency telemetry systems for industrial assets, metering, monitoring, and grid operations.",
      image: EnergyTradingImage,
    },
    {
      title: "VPP Platform",
      text: "Virtual power plant controls for DER assets, dispatch, aggregation, and real-time operational visibility.",
      image: GridBalancingImage,
    },
    {
      title: "CPO Platform",
      text: "OCPP EV charger platform for smart charging, load shifting, flexibility, and V2G use cases.",
      image: CpoPlatformImage,
    },
  ];

  const navigate = (path) => {
    window.location.hash = path.replace("/#", "#");
  };

  return (
    <div className="container-fluid p-0">
      {/* <navbar /> */}
      <section className={classes.NavSection}>
        <Navbar />
      </section>
      {/* top section */}
      <section id="home" className={classes.HeroSection}>
        <div className="container">
          <div className="row mt-3 g-4 align-items-stretch">
            <div className="col-lg-5 mt-1">
              <div className={classes.PageTitle}>
                Balancing Energy. Strengthening Grids.
              </div>
              <div className={classes.PageSubTitle}>
                Energy services for a more balanced grid, spanning power
                supply, energy trading, grid balancing, ancillary services, and
                critical equipment delivery, plus Industrial IoT telemetry and
                VPP/CPO software for DER assets and OCPP EV chargers.
              </div>
              <div className={classes.HeroStats}>
                <div>
                  <strong>24/7</strong>
                  <span>grid support readiness</span>
                </div>
                <div>
                  <strong>4</strong>
                  <span>energy and digital grid services</span>
                </div>
              </div>
              <div>
                <button
                  className={classes.ContactBtn + " btn btn-dark"}
                  onClick={() => navigate("/#contact")}
                >
                  Contact Us
                </button>
              </div>
            </div>
            <div className="col-lg-7 mt-1">
              <div className={classes.TopImageContainer}>
                <div className={classes.TopImageText}>
                  <div className={classes.TopImageTextTitle}>
                    Flexible assets for real grid needs
                  </div>
                  <div className={classes.TopImageTextSubTitle}>
                    We deliver and operate load banks, battery systems,
                    generators, and supporting services that help energy teams
                    respond to supply pressure, grid-balancing requirements,
                    DER control needs, and EV charging flexibility.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2 g-4 align-items-stretch">
            <div className="col-lg-5 d-flex">
              <div
                className={
                  classes.TopTwoimageContainer + ` ${classes.InnovateCont}`
                }
              >
                <div className={classes.TopTwoimageText}>
                  <div className={classes.TopTwoImageTextTitle}>
                    Supply. Trade. Balance.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="row g-4 h-100">
                <div className="col-md-6 d-flex">
                  <div
                    className={
                      classes.TopTwoimageContainer + ` ${classes.SmartCont}`
                    }
                  >
                    <div className={classes.TopTwoimageText}>
                      <div className={classes.TopTwoImageTextTitle}>
                        Load banks and batteries
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div
                    className={
                      classes.TopTwoimageContainer + ` ${classes.SecureCont}`
                    }
                  >
                    <div className={classes.TopTwoimageText}>
                      <div className={classes.TopTwoImageTextTitle}>
                        VPP, CPO and Industrial IoT
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* services section */}
      <section id="services" className={classes.ServicesSection + " mt-5"}>
        <div className="container">
          <div className="row g-4">
            <div className="col-md-7 d-flex flex-column justify-content-center">
              <div className={classes.SectionEyebrow}>What we do</div>
              <div className={classes.ServiceTitle}>Services we offer</div>
            </div>
            <div className="col-md-5">
              <div className={classes.ServiceSubTitle}>
                We combine market knowledge, physical assets, and operational
                delivery with high-frequency telemetry and VPP control systems
                to help utilities, industrial sites, and energy partners manage
                DER assets, OCPP EV chargers, demand, reserve capacity, load
                shifting, and grid stability.
              </div>
              <div>
                <button
                  className={classes.ContactBtn + " btn btn-light"}
                  onClick={() => navigate("/#contact")}
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <CustomCarousel>
              {carouselContent.map((item) => (
                <div
                  className={classes.CaruImageConatainer}
                  key={item.title}
                  style={{
                    backgroundImage: "url(" + item.image + ")",
                  }}
                >
                  <div className={classes.CaruImageOverlay}></div>
                  <div className={classes.CaruImageTitle}>{item.title}</div>
                  <div className={classes.CaruImageText}>{item.text}</div>
                </div>
              ))}
            </CustomCarousel>
          </div>
        </div>
      </section>

      {/* know our team */}
      <section id="about" className="mt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 d-flex flex-column justify-content-center">
              <div>
                <div className={classes.SectionEyebrowDark}>Who we are</div>
                <div className={classes.KnowTitle}>Know our team</div>
                <div className={classes.KnowSubTitle}>
                  VoltHertz Technologies Pvt Ltd works in the energy sector,
                  helping organizations secure flexible power, participate in
                  energy markets, and deploy equipment that supports grid
                  balancing.
                </div>
                <div className={classes.KnowSubTitle}>
                  Our team brings practical experience across energy supply,
                  trading, batteries, load banks, generators, and field service
                  delivery, along with Industrial IoT systems for telemetry and
                  VPP and CPO platforms for controlling distributed energy
                  resources and OCPP EV chargers.
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className={classes.KnowImageContainer}></div>
            </div>
          </div>
        </div>
      </section>

      {/* why us */}
      <section className={classes.WhySection + " mt-5"}>
        <div className={classes.SectionEyebrow}>
          Why VoltHertz Technologies Pvt Ltd
        </div>
        <div className={classes.WhyTitle}>Why choose us?</div>
        <div className="container">
          <div className="row ">
            <div className="col-lg-7 d-flex justify-content-center align-items-center">
              <div className={classes.WhyImageContainer}></div>
            </div>
            <div className="col-lg-5 mt-4">
              <div>
                <div className={classes.WhyPointTitle}>Experience</div>
                <div className={classes.WhySubTitle}>
                  We understand energy-market operations, grid constraints, and
                  the practical demands of delivering power assets on site.
                </div>
                <div className={classes.WhyPointTitle}>
                  Quality and reliability
                </div>
                <div className={classes.WhySubTitle}>
                  We focus on dependable equipment, disciplined deployment, and
                  responsive service for critical balancing and backup needs.
                </div>
                <div className={classes.WhyPointTitle}>
                  Digital grid systems
                </div>
                <div className={classes.WhySubTitle}>
                  We build Industrial IoT systems for high-frequency telemetry
                  data and VPP platforms for monitoring, dispatching, and
                  controlling DER assets and OCPP EV charging networks.
                </div>
                <div className={classes.WhyPointTitle}>EV charging flexibility</div>
                <div className={classes.WhySubTitle}>
                  Our CPO platform supports smart charging, load shifting,
                  flexibility services, and V2G-ready workflows for EV charger
                  fleets.
                </div>
                <div className={classes.WhyPointTitle}>Flexible capacity</div>
                <div className={classes.WhySubTitle}>
                  Load banks, batteries, and gensets can be configured for
                  testing, reserve capacity, demand response, and ancillary
                  service opportunities.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* contact us */}
      <section id="contact" className="mt-5 mb-5">
        <ContactUs />
      </section>
      {/* <footer /> */}
      <section className={classes.FooterSection}>
        <Footer />
      </section>
    </div>
  );
};

export default Home;
